import React, { useContext, useMemo, } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeSwitch as AcidThemeSwitch } from '@michelin/acid-components';
import { CentralProviderContext } from '../../../centralProviderContext/CentralProviderContext';
var buildThemeOptions = function (t, themes) {
    var themeOptions = {
        on: {
            value: themes.on,
            switchToLabel: t('Switch to Light Theme'),
        },
        off: {
            value: themes.off,
            switchToLabel: t('Switch to Dark Theme'),
        },
    };
    return themeOptions;
};
var isThemeSwitchable = function (themes) {
    return (themes === null || themes === void 0 ? void 0 : themes.off) !== undefined;
};
export function ThemeSwitch() {
    var t = useTranslation().t;
    var _a = useContext(CentralProviderContext), themes = _a.themes, currentTheme = _a.currentTheme, setCurrentTheme = _a.setCurrentTheme, allowThemeSwitcher = _a.allowThemeSwitcher;
    var canSwitchThemes = isThemeSwitchable(themes);
    var themeOptions = useMemo(function () {
        if (!canSwitchThemes)
            return undefined;
        return buildThemeOptions(t, themes);
    }, [themes]);
    var handleChange = useMemo(function () { return function (newTheme) {
        setCurrentTheme(newTheme);
    }; }, [setCurrentTheme]);
    if (!allowThemeSwitcher || !themeOptions)
        return null;
    return (React.createElement(AcidThemeSwitch, { themeOptions: themeOptions, selectedTheme: currentTheme, onSwitchTheme: handleChange }));
}
//# sourceMappingURL=ThemeSwitch.js.map